import { APIRoutes } from "@/api";
import { channelSchema } from "@/controllers/channel/schema";
import { queryClient } from "@/lib/query-client";
import { ApiService } from "@/services/api/api-service";
import {
  QueryFunctionContext,
  UseQueryOptions,
  useQuery as useQueryTanstack,
} from "@tanstack/react-query";
import { z } from "zod";

async function getMeChats({ signal }: QueryFunctionContext) {
  const data = await fetch(APIRoutes.USER_CHATS, {
    cache: "no-cache",
    signal,
  }).then((res) => res.json());

  const response = ApiService.parseApiResponse(data, z.array(channelSchema));

  if (response.status === "error") {
    return [];
  } else {
    return response.data;
  }
}

type TData = Awaited<ReturnType<typeof getMeChats>>;

export namespace MeChatsQuery {
  export const queryKey = ["me-chats"];

  export function invalidate() {
    return queryClient.invalidateQueries({ queryKey });
  }

  export function useQuery(
    options?: Omit<
      UseQueryOptions<TData>,
      "queryKey" | "queryFn" | "initialData"
    >,
  ) {
    return useQueryTanstack({
      queryKey,
      queryFn: getMeChats,
      ...options,
    });
  }
}
